// Protected Route wrapper for authentication-required pages
import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { Spinner } from 'react-bootstrap';
import SignInGate from './SignInGate';

/**
 * Wraps routes that require authentication. Signed-out visitors stay on the
 * URL they asked for, see a short explanation, and get the login modal.
 */
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <Spinner animation="border" variant="primary" />
        <span className="visually-hidden">Checking your sign-in…</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    try {
      sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    } catch { /* private browsing — the redirect is a nicety, not a requirement */ }

    return <SignInGate />;
  }

  return children;
};

export default ProtectedRoute;
